<script>

  /*
  |--------------------------------------------------------------------------
  | Dependency Definitions
  |--------------------------------------------------------------------------
  */

  import Vue from 'vue';
  import vueDebounce from 'vue-debounce'

  Vue.use(vueDebounce);

  import axios from 'axios';



  /*
  |--------------------------------------------------------------------------
  | Component Implementation
  |--------------------------------------------------------------------------
  */

  export default {
    name: 'freight-cost-calculator',

    props: [
      'product',
      'language'
    ],

    mounted() {
      console.log("Product: ", this.product);
    },

    data() {
      return {
        postalCode: '',

        freightCalculated: false,
        freightCost: 0,
        freightCurrency: 'SEK',
        freightError: false
      }
    },

    computed: {
      postalCodePlaceholder() {
        if (this.language == 'sv') {
          return 'Ange postnummer';
        }

        return 'Enter postal code';
      },

      calculateFreightCostButtonText() {
        if (this.language == 'sv') {
          return 'Beräkna fraktkostnad';
        }

        return 'Calculate freight cost';
      },

      freightCostText() {
        if (this.language == 'sv') {
          var freightText = 'Den beräknade fraktkostnaden är: ';

          let freightCostText = this.freightCost.toLocaleString('SE-sv', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 0
          });

          freightText += '<strong>' + freightCostText;
          freightText += ' ' + this.freightCurrency + '</strong>';
          // freightText += '. Kostnaden är en uppskattning baserad på frakt av en produkt inom Sverige.';

          return freightText;
        }

        var freightText = 'The calculated freight cost is: ';

        freightText += this.freightCost;
        freightText += ' ' + this.freightCurrency;
        freightText += '. The cost is an estimation based on freighting one product within Sweden.';

        return freightText;
      },

      freightCostErrorText() {
        if (this.language == 'sv') {
          return 'Fraktkostnaden kunde inte beräknas. Kontrollera att postnumret innehåller 5 tecken och att det är ett giltigt svenskt postnummer.';
        }

        return 'The freight cost could not be calculated. Please check that the postal code contains 5 characters and is a valid Swedish postal code.';
      },
    },

    methods: {
      calculateFreightCost() {
        var self = this;

        var volume = this.product.transport_volume_sv;
        volume = volume.replace(' ', '');
        volume = volume.replace(',', '.');
        volume = parseFloat(volume);

        var service = 'DhlSweden_DhlStycke';
        var weight = this.product.volumetric_weight_sv;
        if (this.product.freight_booking_sv != null && this.product.freight_booking_sv.toLowerCase().includes('flm')) {
          service = 'DhlSweden_DhlParti';
          volume = this.product.freight_booking_sv;
          volume = volume.replace('flm', '');
          volume = volume.replace(' ', '');
          volume = volume.replace(',', '.');
          volume = parseFloat(volume);

          weight = volume * 1950;

          if (weight < 1000) {
            var service = 'DhlSweden_DhlStycke';
          }
        }

        console.log("postal_code: ", this.postalCode);
        console.log("weight: ", weight);
        console.log("volume: ", volume);
        console.log("service: ", service);

        axios.post('/api/v1/freight_cost_calculator', {
          postal_code: this.postalCode,
          weight: weight,
          volume: volume,
          service: service
        })
        .then(function (response) {
          if (response.data.success) {
            self.freightError = false;
            self.freightCost = Math.round(response.data.priceQuote).toFixed(0);
            self.freightCurrency = response.data.priceQuoteCurrency;
            self.freightCalculated = true;
          } else {
            self.freightError = true;
            self.freightCost = 0;
            self.freightCurrency = 'SEK';
            self.freightCalculated = false;
          }
          console.log("Response: ", response);
        })
        .catch(function (error) {
          console.log("Error calculating freight cost: ", error);

          self.freightError = true;
          self.freightCost = 0;
          self.freightCurrency = 'SEK';
          self.freightCalculated = false;
        });
      }
    }
  };
</script>

<template>
  <div>
		<div class="row calculator">
			<div class="col-12 col-md-6">
				<input v-model="postalCode" :placeholder="postalCodePlaceholder"></input>
			</div>
			<div class="col-12 col-md-6">
				<button @click="calculateFreightCost">{{ calculateFreightCostButtonText }}</button>
			</div>
		</div>
		<div class="col-12 pt-3">
			<p v-if="freightCalculated" v-html="freightCostText"></p>
			<p v-if="freightError">{{ freightCostErrorText }}</p>
      <p class=""><small>Observera att denna fraktgenerator endast ger ett ungefärligt pris på en produkt inom Sverige. Det verkliga fraktpriset kan skilja sig från det som anges här. Vissa produkter över 35 kg kräver egen pall/lastbärare som ökar fraktkostnaden, detta är inte medräknat i fraktgeneratorn. Vissa mindre produkter som kan skickas som ”Paket” har normalt ett pris mellan 150-200kr inom Sverige.</small></p>
		</div>
  </div>
</template>
